import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const fromLocation = location.state?.from;
  const from = fromLocation ? `${fromLocation.pathname}${fromLocation.search || ''}` : '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-sand-50">
      {/* Left brand panel — desktop only */}
      <div className="hidden lg:flex flex-col justify-center px-16 bg-terra-400/10 border-r border-sand-200 w-2/5 shrink-0">
        <p className="font-heading text-4xl font-bold text-ink-900 mb-4 leading-tight">
          Welcome back to Dayra
        </p>
        <p className="text-base text-ink-400 leading-relaxed">
          Your local marketplace for trusted services and skilled providers across the UAE.
        </p>
      </div>

      {/* Right form panel */}
      <div className="flex-1 flex items-center justify-center px-4 sm:px-8 py-12">
        <div className="w-full max-w-sm">
          <p className="font-heading text-2xl font-semibold text-ink-900 mb-1">Sign in</p>
          <p className="text-sm text-ink-400 mb-8">Enter your email and password to continue</p>

          {error && (
            <div className="mb-4 px-4 py-3 bg-uae-red/10 border border-uae-red/20 rounded-lg text-sm text-uae-red">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <Input
              id="email"
              label="Email"
              type="email"
              value={form.email}
              onChange={e => setForm({ ...form, email: e.target.value })}
              placeholder="you@example.com"
              required
            />
            <Input
              id="password"
              label="Password"
              type="password"
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
              required
            />
            <Button type="submit" variant="primary" loading={loading} className="w-full justify-center mt-2">
              Sign in
            </Button>
          </form>

          <div className="mt-3 text-right">
            <Link to="/forgot-password" className="text-sm text-ink-400 hover:text-terra-400 transition-colors">
              Forgot password?
            </Link>
          </div>

          <p className="text-sm text-ink-400 mt-6 text-center">
            Don't have an account?{' '}
            <Link to="/signup" className="text-terra-400 font-medium hover:text-terra-500 transition-colors">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
